(function () {
    "use strict";
    angular.module("Directives").directive("bbaMapSidebar", bbaMapSidebar);
    bbaMapSidebar.$inject = [
        '$q',
        '$rootScope',
        'FleetService',
        'toastr',
        'MapLegendsConst',
        'ConfirmationModalFactory',
        '$uibModal'
    ];

    function bbaMapSidebar(
        $q,
        $rootScope,
        FleetService,
        toastr,
        MapLegendsConst,
        ConfirmationModalFactory,
        $uibModal
    ) {
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/components/job-map/bba-map-sidebar.html',
            scope: {
                ngModel: '=', // store selected jobs here
            },
            link: bbaMapSidebarLink
        }

        function bbaMapSidebarLink(scope, element, attrs) {
            scope.loadingDataMain = false;
            scope.approvingJobs = false;
            scope.sideBarData = {};
            scope.loadJobs = loadJobs;

            scope.selectedForApprovalJobs = [];
            scope.selectUnapprovedJob = selectUnapprovedJob;
            scope.approveSelected = approveSelected;

            scope.advanceSearchValue = {};
            scope.openAdvancedSearch = openAdvancedSearch;
            scope.clearFilter = clearFilter;

            scope.focusJob = focusJob;
            scope.backToAreas = backToAreas;

            const approveJobConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.approveJob.MESSAGE',
                code: 'messages.warning.approveJob.CODE',
            });

            const jobStatuses = [
                'UNASSIGNED',
                'FORAPPROVAL',
                'PENDING',
                'ACCEPTED',
                'RECEIVED',
                'INPROGRESS',
                'FAILED'
            ];

            init();
            function init() {
                loadAreasOnSideBar();

                // listen for view job event from the bbaMap directive
                $rootScope.$on("viewJobRoute", (event, job) => {
                    loadRoutesOnSideBar(job.route.id).then(data => {
                        loadJobs(data[0], "Routes", true);
                    });
                });

                // listen for view job area event from bbaMap directive
                $rootScope.$on("viewJobArea", (event, area) => {
                    loadAreasOnSideBar(area.id).then(data => {
                        loadJobs({
                            id: data[0].id,
                            name: data[0].areaId,
                            collapseEnabled: false
                        }, "Areas", true);
                    });
                });

                // listen fro view job driver event from bbaMap directive
                $rootScope.$on("viewJobDriver", (event, driver) => {
                    loadDriversOnSidebar(driver.id).then( data => {
                        loadJobs({
                            id: data[0].id,
                            name: `${data[0].firstName} ${data[0].lastName}`,
                            collapseEnabled: false
                        }, "Drivers", true);
                    });
                });
            }

            function loadAreasOnSideBar(areaId = null) {
                scope.loadingDataMain = true;
                const defer = $q.defer();
                const filter = areaId != null ? { "id": areaId } : {};

                getAreas(filter).then(data => {
                    scope.sideBarData = {
                        label: 'Areas',
                        mainData: data.map(data => {
                            return {
                                id: data.id,
                                name: data.areaId,
                                collapseJobs: false
                            }
                        })
                    }
                    scope.loadingDataMain = false;
                    defer.resolve(data);
                }, error => {
                    scope.loadingDataMain = false;
                    defer.reject(error);
                });
                return defer.promise;
            }

            function getAreas(filter = {}) {
                let deffered = $q.defer();
                FleetService.Areas.getAll(success => {
                    deffered.resolve(success.content);
                }, error => {
                    toastr.error('Unable to load areas', error.message);
                    deffered.reject(error);
                }, angular.extend({
                    active: true,
                    size: 10,
                    sort: 'id,asc'
                }, filter));
                return deffered.promise;
            }

            function loadRoutesOnSideBar(routeId = null) {
                scope.loadingDataMain = true;
                const defer = $q.defer();
                const filter = routeId != null ? { "id": routeId } : {};

                getRoutes(filter).then(data => {
                    scope.sideBarData = {
                        label: 'Routes',
                        mainData: data.map(data => {
                            return {
                                id: data.id,
                                name: data.name,
                                collapseJobs: false
                            }
                        })
                    }

                    scope.loadingDataMain = false;
                    defer.resolve(data);
                }, error => {
                    scope.loadingDataMain = false;
                    defer.reject(error);
                });
                return defer.promise;
            }

            function search(keyword, filters) {
                const defer = $q.defer();
                FleetService.multiSearch( data => {
                    // TODO add implementation code for multi-search function
                    console.log(data);
                }, error => {
                    toastr.error('Unable to perform search', error.message);
                }, angular.extend({ keyword, size: 200 }, filters || {}));
                return defer.promise;
            }

            function getRoutes(filter = {}) {
                const defer = $q.defer();
                FleetService.Routes.getRoutes(data => {
                    defer.resolve(data.content);
                }, err => {
                    toastr.error('Unable to load routes', err.message);
                    defer.reject(err);
                }, angular.extend({
                    size: 10,
                    sort: 'id,asc'
                }, filter));
                return defer.promise;
            }

            function loadDriversOnSidebar(driverId = null) {
                scope.loadingDataMain = true;
                const defer = $q.defer();
                const filter = driverId != null ? { "id": driverId } : {};

                getAllDrivers(filter).then( data => {
                    scope.sideBarData = {
                        label: 'Drivers',
                        mainData: data.map(data => {
                            return {
                                id: data.id,
                                name: `${data.firstName} ${data.lastName}`,
                                collapseJobs: false
                            }
                        })
                    }
                    scope.loadingDataMain = false;
                    defer.resolve(data);
                }, error => {
                    scope.loadingDataMain = false;
                    defer.reject(error);
                });
                return defer.promise;
            }

            function getAllDrivers(filter = {}) {
                const defer = $q.defer();
                FleetService.Drivers.getAll(data => {
                    defer.resolve(data.content);
                }, error => {
                    toastr.error('Unable to load drivers', error.message);
                    defer.reject(error);
                },angular.extend({
                        size: 100,
                        sort: 'id,asc'
                    }, filter));
                return defer.promise;
            }

            function loadJobStatusOnSidebar(jobStatus = null) {
                const defer = $q.defer();
                scope.sideBarData = {
                    label: 'Job Statuses',
                    mainData: jobStatus == null ? jobStatuses.map( data => {
                        return {
                            id: data,
                            name: data,
                            collapseJobs: false
                        }
                    }) : [{
                        id: jobStatus,
                        name: jobStatus,
                        collapseJobs: false
                    }]
                }
                defer.resolve(scope.sideBarData.mainData);
                return defer.promise;
            }

            function loadJobs(selectedData, label, collapseEnabled = false) {
                scope.sideBarData.mainData.forEach(data => {
                    if (data.id == selectedData.id) {
                        if (collapseEnabled) {
                            if (selectedData.collapseJobs) {
                                selectedData.jobsData = undefined;
                            }
                            data.collapseJobs = !selectedData.collapseJobs;
                            selectedData.page = undefined;
                            scope.selectedForApprovalJobs = [];
                        }

                        if (data.collapseJobs) {
                            switch (label) {
                                case "Areas":
                                    data.loading = true;
                                    getAllJobs({
                                        "route.area.id": selectedData.id,
                                        page: selectedData.page == undefined ? 0 : selectedData.page + 1
                                    }).then(jobs => {
                                        parseJobsAndLoadToView(jobs, data, collapseEnabled);
                                        addWayPointsToNgModel({}, {}); // clear waypoints and office in ngModel
                                        addFocusDriverToNgModel({}); // clear driver in ngModel
                                    }).finally(() => {
                                        data.loading = false;
                                    });
                                    break;
                                case "Routes":
                                    data.loading = true;
                                    $q.all({
                                        jobs: getAllJobs({
                                            "route.id": selectedData.id,
                                            page: selectedData.page == undefined ? 0 : selectedData.page + 1
                                        }),
                                        wayPoints: getWayPoints(selectedData.id)
                                    }).then(returnedData => {
                                        parseJobsAndLoadToView(returnedData.jobs, data, collapseEnabled);
                                        addWayPointsToNgModel(
                                            returnedData.wayPoints,
                                            returnedData.jobs.content.length != 0 ? returnedData.jobs.content[0].route.office : []);
                                        addFocusDriverToNgModel({}); // clear driver in ngModel
                                    }).finally(() => {
                                        data.loading = false;
                                    });
                                    break;
                                case "Drivers": 
                                    data.loading = true;
                                    getAllJobs({
                                        "driver.id": selectedData.id,
                                        page: selectedData.page == undefined ? 0 : selectedData.page + 1
                                    }).then( jobs => {
                                        parseJobsAndLoadToView(jobs, data, collapseEnabled);
                                        addWayPointsToNgModel({}, {}); // clear waypoints and office in ngModel
                                        addFocusDriverToNgModel({
                                            id: selectedData.id,
                                            name: selectedData.name
                                        });
                                    }).finally(() => {
                                        data.loading = false;
                                    });
                                    break;
                                case "Job Statuses":
                                    data.loading = true;
                                    getAllJobs({
                                        jobStatuses: [selectedData.id],
                                        page: selectedData.page == undefined ? 0 : selectedData.page + 1
                                    }).then( jobs => {
                                        parseJobsAndLoadToView(jobs, data, collapseEnabled);
                                        addWayPointsToNgModel({}, {}); // clear waypoints and office in ngModel
                                        addFocusDriverToNgModel({}); // clear driver in ngModel
                                    }).finally(() => {
                                        data.loading = false;
                                    });
                                    break;
                            }
                        }
                    } else {
                        data.collapseJobs = false;
                    }
                });
            }

            function parseJobsAndLoadToView(jobs, parentData, collapseEnabled) {
                parentData.page = jobs.number;
                parentData.totalPages = jobs.totalPages;
                let tmpJobs = jobs.content.map(x => {
                    return angular.extend({
                        icon: getJobMarker(x)
                    }, x);
                });
                if (collapseEnabled) {
                    parentData.jobsData = tmpJobs;
                } else {
                    parentData.jobsData.push(...tmpJobs);
                }
                addJobsToNgModel(parentData.jobsData);
            }

            function addJobsToNgModel(jobs) {
                scope.ngModel.jobs = jobs;
            }

            function addWayPointsToNgModel(wayPoints, office) {
                scope.ngModel.wayPoints.office = office;
                scope.ngModel.wayPoints.points = wayPoints;
            }

            function addFocusDriverToNgModel(driver){
                scope.ngModel.focusDriver = driver;
            }

            function getJobMarker(job) {
                let jType = null;

                if (job.isReturn === 'returns') {
                    jType = 'ret';
                }
                else if (job.type === 'pickuponly' || job.type === 'delivery') {
                    jType = 'mr';
                }
                else if (job.type === 'p2p') {
                    jType = 'p2p';
                }
                else {
                    jType = 'mr';
                }

                const jobStatusColor = MapLegendsConst.statuses.filter(status => {
                    return status.id === job.jobStatus.toUpperCase();
                });

                return angular.extend({
                    scaledSize: new google.maps.Size(39.2, 38.5),
                    anchor: new google.maps.Point(19.6, 38.5),
                }, MapLegendsConst.getIcons(jType, jobStatusColor[0]));
            }

            function selectUnapprovedJob(jobData) {
                const existingIndex = scope.selectedForApprovalJobs.findIndex(job => job.id === jobData.id);
                if (jobData.selected) {
                    if (existingIndex < 0) {
                        scope.selectedForApprovalJobs.push(jobData);
                    }
                } else if (existingIndex => 0 && !jobData.selected) {
                    scope.selectedForApprovalJobs.splice(existingIndex, 1);
                }
            }

            function approveSelected() {
                if (scope.selectedForApprovalJobs.length != 0) {
                    approveJobConfirmation.getInstance().result.then(cond => {
                        if (cond) {
                            scope.approvingJobs = true;
                            FleetService.Jobs.updateStatus(scope.selectedForApprovalJobs.map(job => job.id),
                                { toStatus: 'PENDING', remarks: 'Approved' },
                                (udpatedJobs) => {
                                    // instead of loading the whole data again we 
                                    // are only updating the job data that is stored in the memmorry
                                    scope.sideBarData.mainData.forEach(data => {
                                        if (data.jobsData != undefined) {
                                            // replace with normal forloop
                                            for (let x = 0; x < data.jobsData.length; x++) {
                                                for (let i = 0; i < udpatedJobs.length; i++) {
                                                    if (udpatedJobs[i].id == data.jobsData[x].id) {
                                                        // udpate the job data and icon
                                                        data.jobsData[x] = udpatedJobs[i];
                                                        data.jobsData[x].icon = getJobMarker(udpatedJobs[i]);
                                                    }
                                                }
                                            }
                                        }
                                    });

                                    toastr.success('Successfully Approved selected jobs');
                                    scope.approvingJobs = false;
                                },
                                error => {
                                    toastr.error('Unable to Approve selected jobs', error.message);
                                    scope.approvingJobs = false;
                                });
                        }
                    });
                } else {
                    toastr.info('No jobs selected');
                }
            }

            function focusJob(jobToFocus) {
                scope.ngModel.jobToFocus = jobToFocus;
            }

            function getAllJobs(filters = {}) {
                const deffered = $q.defer();
                let defaultFilters = angular.extend({
                    sort: 'createdDate,asc',
                    size: 20,
                    jobStatus: filters.jobStatuses != undefined ? filters.jobStatuses : jobStatuses
                }, filters);
                
                if(scope.advanceSearchValue.filterBy != undefined) {
                    if(scope.advanceSearchValue.filterBy.name == 'Status') {
                        defaultFilters = angular.extend(defaultFilters, {
                            jobStatus: [scope.advanceSearchValue.filterBy.value]
                        });
                    } else {
                        defaultFilters = angular.extend(defaultFilters, {
                            [scope.advanceSearchValue.filterBy.filterBy]: scope.advanceSearchValue.filterBy.value.id
                        });
                    }
                }

                FleetService.Jobs.getAll(success => {
                    deffered.resolve(success);
                }, error => {
                    deffered.reject(error);
                    toastr.error('Unable to load jobs', error.message);
                }, defaultFilters);
                return deffered.promise;
            }

            function getWayPoints(routeId) {
                const defer = $q.defer();
                FleetService.Routes.getMapRoute(route => {
                    defer.resolve(route.routes[0]);
                }, err => {
                    toastr.error('Unable to load route', err.message);
                    defer.resolve(null);
                }, {
                        routeId: routeId
                    });
                return defer.promise;
            }

            function openAdvancedSearch() {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/jobs/add-ons/AdvancedSearchModal.html',
                    controller: 'AdvancedSearchModalController',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        category: function () {
                            return scope.advanceSearchValue;
                        },
                        getAreas: () => getAreas,
                        getRoutes: () => getRoutes,
                        getDrivers: () => getAllDrivers,
                    }
                }).result.then((data) => {
                    advanceSearchFilterHandler(data);
                });
            }

            function advanceSearchFilterHandler(data){
                if(angular.getObjVal(data, 'performSearch') == true){
                    search(data.search.keyword, {});
                } else {
                    switch(angular.getObjVal(data, 'groupBy')) {
                        case 'Area':
                            if(data.filterBy != undefined) {
                                if(data.groupBy == data.filterBy.name) {
                                    loadAreasOnSideBar(data.filterBy.value.id).then( data => {
                                        loadJobs({
                                            id: data[0].id,
                                            name: data[0].areaId,
                                            collapseEnabled: false
                                        }, "Areas", true);
                                    });
                                } else {
                                    loadAreasOnSideBar();
                                }
                            } else {
                                loadAreasOnSideBar();
                            }
                            break;
                        case 'Route':
                            if(data.filterBy != undefined) {
                                if(data.groupBy == data.filterBy.name) {
                                    loadRoutesOnSideBar(data.filterBy.value.id).then( data => {
                                        loadJobs({
                                            id: data[0].id,
                                            name: data[0].name,
                                            collapseEnabled: false
                                        }, "Routes", true);
                                    });
                                } else {
                                    loadRoutesOnSideBar();
                                }
                            } else {
                                loadRoutesOnSideBar();
                            }
                            break;
                        case 'Driver': 
                            if(data.filterBy != undefined) {
                                if(data.groupBy == data.filterBy.name) {
                                    loadDriversOnSidebar(data.filterBy.value.id).then( data => {
                                        loadJobs({
                                            id: data[0].id,
                                            name: `${data[0].firstName} ${data[0].lastName}`,
                                            collapseEnabled: false
                                        }, "Drivers", true);
                                    });
                                }
                                else {
                                    loadDriversOnSidebar();
                                }
                            } else {
                                loadDriversOnSidebar();
                            }
                            break;
                        case 'Status':
                            if(data.filterBy != undefined) {
                                if(data.groupBy == data.filterBy.name) {
                                    loadJobStatusOnSidebar(data.filterBy.value).then( data => {
                                        loadJobs({
                                            id: data[0].id,
                                            name: data[0].name,
                                            collapseEnabled: false
                                        }, "Job Statuses", true);
                                    });
                                } else {
                                    loadJobStatusOnSidebar();
                                }
                            } else {
                                loadJobStatusOnSidebar();
                            }

                            break;
                    }
                }
            }

            function backToAreas(){
                loadAreasOnSideBar();
                scope.advanceSearchValue = {};
            }

            function clearFilter() {
                scope.advanceSearchValue = {};
            }
        }
    }
})()



// WEBPACK FOOTER //
// ./js/directives/component/job-map/bbaMapSidebar.js